import { render, staticRenderFns } from "./TroubleshootingTab.vue?vue&type=template&id=bfd2b88e&scoped=true&"
import script from "./TroubleshootingTab.vue?vue&type=script&lang=js&"
export * from "./TroubleshootingTab.vue?vue&type=script&lang=js&"
import style0 from "./TroubleshootingTab.vue?vue&type=style&index=0&id=bfd2b88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd2b88e",
  null
  
)

export default component.exports